import React from "react";
import styles from "./adPrice.scss";
import { displayPrice, parsePriceString } from "../../../../services";

const AdPrice = ({ price, priceTo, previousPrice, className, rentPriceType , priceType }) => {
  if (!price || price === 0) {
    return null;
  }

  return (
    <React.Fragment>
      <span className={`${styles.price} ${className}`}>
        {displayPrice(price, priceTo, {rentPriceType, priceType})}
      </span>
      {previousPrice && (
        <span className={styles.prevPrice}>
          {parsePriceString(previousPrice)}
        </span>
      )}
    </React.Fragment>
  );
};

AdPrice.defaultProps = {
  className: ""
}

export default AdPrice;



// WEBPACK FOOTER //
// ./src/components/SimilarAdCard/AdSummary/AdPrice/AdPrice.tsx